
<div v-if="items" class="index-container" style="position: relative" v-resize="onResize">
    <v-row class="no-frame">
        <v-slide-x-transition>
            <v-col class="no-frame col-3" v-show="show" :style="style">
                <v-expansion-panels
                    v-model = "expandFilter"
                    style   = "padding-right: 15px;"
                    accordion
                    flat
                >
                    <v-expansion-panel class="pa-0" :key="1">
                        <div style="height: 13px;"></div>
                        <v-expansion-panel-header :ripple="false" expand-icon="" hide-actions class="pa-0" >
                            <div>
                                <c-column-header
                                    :label = "title"
                                    class = "primary"
                                    style = "font-size: 16px;"
                                >
                                    <template v-slot:filter>
                                        <div>
                                            <slot name="pre-filter" />
                                        </div>
                                        <c-item-count :count="count" />
                                        <div>
                                            <a @click.stop="onFilter">
                                                <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                                            </a>

                                            <a
                                                @click.stop = "onRemoveFilter"
                                                v-show      = "filterOn || (search && search.length > 0)"
                                            >
                                                <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                                            </a>
                                        </div>
                                    </template>

                                </c-column-header>
                            </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content eager class="pa-0 pt-1 ma-0 mb-0" style="border-top-left-radius: 0!important; border-top-right-radius: 0!important;">
                            <div>
                                <slot name="filter"></slot>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <div class="pb-1 mt-3" v-if="enableSearch">
                    <v-text-field
                        v-model        = "search"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        append-icon    = "fas fa-search"
                        ref            = "search"
                        class          = "pt-0 pb-4 mr-4"
                        clearable
                        hide-details
                    />
                </div>

                <slot name="pre-index" />
                <div
                    class="index-block"
                    :style="indexStyle"
                    :key="refreshKey"
                >
                    <v-virtual-scroll
                        :items="letterlist2"
                        height="height"
                        item-height="30"
                        class="index-scroll"
                        bench="1"
                    >
                        <template v-slot:default="{ item }">
                            <div class="pr-2 mr-1">
                                <div class="letter-block pl-1" v-if="item.type === 'letter'"
                                     style="width: calc(100% + 10px)"
                                >
                                    {{ item.value}}
                                </div>
                                <div v-if="item.type === 'item'"
                                     class="v-flex pl-3 pl-3"
                                >
                                    <a @click="onItem(item.value)" class="w-100">
                                        <div
                                            class="pl-2 pr-0 pt-1 v-flex"
                                            style="width: calc(100% + 10px)"
                                            :class="selected && selected.id === item.value.id ? 'item-row-selected' : 'item-row'"
                                        >
                                            <slot name="item" v-bind:item="item.value"></slot>
                                        </div>
                                    </a>
                                </div>
                                <div v-if="item.type === 'child'"
                                     class="v-flex pl-3 pl-6"
                                     :class="item.last ? 'last-branch' : 'branch'"
                                >
                                    <a @click="onItem(item.value)" class="w-100">
                                        <div
                                            class="pl-2 pr-2 pt-1 v-flex"
                                            style="width: calc(100% + 10px)"
                                            :class="selected && selected.id === item.value.id ? 'item-row-selected' : 'item-row'"
                                        >
                                            <slot name="item" v-bind:item="item.value"></slot>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </template>
                    </v-virtual-scroll>
                </div>
            </v-col>
        </v-slide-x-transition>
        <v-col class="no-frame detail-block" :class="show ? 'col-9' : 'col-12'" :style="detailStyle">
            <div
                class="bxx"
                v-if="selected && miminize"
                :style="show ? 'left: calc(25% - 14px)!important;' : 'left: -15px;'"
            >
                <v-btn
                    fab
                    x-small
                    depressed
                    color="primary"
                    @click="onSide"
                    style="height: 28px;width: 28px;"
                >
                    <v-icon size="28">{{ show ?  'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
                </v-btn>
            </div>
            <div :style="'height:' + height + 'px' ">
                <slot name="detail" v-bind:item="{ item: selected, show: show }"></slot>
            </div>
        </v-col>
    </v-row>
</div>
